(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de');
  // Curated demand estimate, 26 October 2026. Club tiers use CIES reach and brand strength as proxies,
  // with model appeal and actual condition as tie-breakers; this is not a live sales ranking.
  const clubs = [
    [/real madrid/,100], [/barcelona|barca/,99], [/manchester united/,96],
    [/bayern/,95], [/liverpool/,94], [/paris saint|paris st.?germain|\bpsg\b/,94],
    [/arsenal/,93], [/manchester city/,92], [/chelsea/,91], [/borussia dortmund|\bbvb\b/,90],
    [/inter mailand|inter milan|internazionale/,88], [/ac milan|ac mailand/,89], [/juventus/,89],
    [/deutschland|germany|\bdfb\b/,87], [/italien|italy/,81], [/portugal/,80],
    [/ajax/,79], [/atletico madrid/,79], [/tottenham/,78], [/napoli|neapel|as rom|as roma/,77],
    [/japan/,76], [/benfica/,75], [/schalke|eintracht frankfurt|hamburger sv|\bhsv\b/,73],
    [/monchengladbach|moenchengladbach|gladbach/,72], [/olympique lyon/,70],
    [/leverkusen|celtic|rangers|fenerbahce|galatasaray/,70], [/schweden|sweden/,65],
    [/fortuna dusseldorf|fortuna duesseldorf/,63], [/rb leipzig/,62], [/mainz/,60],
    [/antalyaspor/,57], [/apoel/,52], [/zypern|cyprus/,48]
  ];
  const score = card => {
    const title = normalize(card.dataset.title), tags = normalize(card.dataset.tags), text = title + ' ' + tags;
    const club = clubs.find(([pattern]) => pattern.test(text));
    let value = (club ? club[1] : 50) * 10;
    if (/rooney|eto.?o|ronaldinho|ronaldo|messi|zidane|kaka|beckham|maldini|henry/.test(text)) value += 35;
    else if (/balotelli|mata|kruse|ze roberto/.test(text)) value += 15;
    const year = Number(card.dataset.year);
    if (year >= 1980 && year < 2010) value += 20;
    else if (year >= 2010 && year < 2020) value += 10;
    if (/langarm/.test(title)) value += 10;
    if (/heimtrikot/.test(title)) value += 5;
    const condition = text.match(/zustand\s*(\d+)\s*\/\s*10/);
    if (condition) value -= Math.max(0, 8 - Number(condition[1])) * 15;
    else if (/neu mit etikett/.test(tags)) value += 15;
    return value;
  };
  window.FoMarketRanking = { score };
})();
